"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StepForwardFill = {
    name: 'step-forward',
    theme: 'fill',
    nameWithTheme: 'step-forward-fill',
    tag: 'svg',
    attrs: { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 1024 1024' },
    children: [
        {
            tag: 'path',
            attrs: {
                d: 'M326.6 76.3L758 431.6V132c0-19.9 16.1-36 36-36s36 16.1 36 36v760c0 19.9-16.1 36-36 36s-36-16.1-36-36V590.6L326.7 947.8c-27.4 24.4-70.8 5-70.8-31.7V107.9c0-36.6 43.4-56.1 70.7-31.6z'
            },
            children: []
        }
    ]
};
exports.default = StepForwardFill;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@1.0.3@@ant-design/icons/lib/fill/StepForwardFill.js
// module id = 659
// module chunks = 0 1